import { Link } from "react-router-dom";
import {
  Factory,
  Sparkles,
  Clock,
  Wrench,
  Hammer,
  Repeat,
  ArrowRight,
} from "lucide-react";
import { Card } from "@/components/ui/card";
import SectionHeader from "./SectionHeader";

const SERVICES = [
  {
    icon: Factory,
    title: "Factory Workforce Supply",
    desc: "Trained operators and helpers for production lines, assembly, packaging, and material handling across factories.",
  },
  {
    icon: Sparkles,
    title: "Housekeeping Staff Recruitment",
    desc: "Disciplined housekeeping personnel for industrial, corporate, and facility management environments.",
  },
  {
    icon: Clock,
    title: "Shift-Based Labor Deployment",
    desc: "Reliable manpower for 12-hour 2-shift and 8-hour 3-shift operations with full statutory compliance.",
  },
  {
    icon: Wrench,
    title: "Industrial Contract Staffing",
    desc: "End-to-end contract staffing for industrial operations including supervision, payroll, and welfare.",
  },
  {
    icon: Hammer,
    title: "Skilled & Semi-Skilled Workers",
    desc: "Welders, machine operators, fitters, electricians, and semi-skilled labor matched to your trade requirements.",
  },
  {
    icon: Repeat,
    title: "Long & Short-Term Staffing",
    desc: "Flexible engagement models from short-term project deployments to long-term operational partnerships.",
  },
];

export default function ServicesGrid({ showCta = true }) {
  return (
    <section
      className="bg-[#F8FAFC] py-16 md:py-24"
      data-testid="services-grid-section"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <SectionHeader
            eyebrow="What we do"
            title="Manpower solutions across industries"
            description="One partner for factory workforce, housekeeping, industrial labor, and shift-based deployments."
            testid="services-grid-header"
          />
          {showCta && (
            <Link
              to="/services"
              data-testid="services-grid-view-all"
              className="inline-flex items-center gap-2 text-sm font-semibold text-[#1E3A8A] hover:text-[#1F6B5C]"
            >
              View all services
              <ArrowRight className="h-4 w-4" />
            </Link>
          )}
        </div>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <Card
                key={s.title}
                data-testid={`service-card-${i}`}
                className="rk-lift relative p-6 sm:p-8 bg-white border border-[#E2E8F0] rounded-sm rk-fade-up"
                style={{ animationDelay: `${i * 80}ms` }}
              >
                <div className="h-12 w-12 grid place-items-center rounded-sm bg-[#1E3A8A]/8 text-[#1E3A8A] border border-[#1E3A8A]/15 group-hover:bg-[#1E3A8A] group-hover:text-white transition-colors">
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="mt-5 font-display text-xl font-bold text-[#0F172A]">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-[#475569]">
                  {s.desc}
                </p>
                <div className="mt-5 inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-[#1F6B5C]">
                  Industry-ready
                  <span className="h-1 w-1 rounded-full bg-[#1F6B5C]" />
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
}
